import { render, staticRenderFns } from "./TaxratesetupEdit.vue?vue&type=template&id=3de5999c"
import script from "./TaxratesetupEdit.vue?vue&type=script&lang=js"
export * from "./TaxratesetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports